import { useQuery } from 'react-query'
import { getWaitingLists } from './waiting-lists.api'

export function useWaitingLists() {
  return useQuery('waitingLists', getWaitingLists)
}
